import { css, cx } from 'emotion';

import {
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	mobileMaxWidthBreakpoint,
	museo900,
	lightGrey,
	darkGrey,
	button,
	aqua,
} from 'inside-out/global-styles';

import DropDownIcon from 'inside-out/images/dropdown-icon.svg';

export const innerWrapperStyle = mapIsToggled =>
	css({
		maxWidth: desktopMaxWidthBreakpoint,
		width: '100%',
		height: '100%',
		margin: '0 auto',
		padding: '0 20px',
		display: 'flex',

		'& > div': {
			width: '50%',
			position: 'relative',
		},
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			flexFlow: 'column',
			'& > div': {
				width: '100%',
				'&:first-child': {
					display: mapIsToggled ? 'none' : 'block',
				},
				'&:last-child': {
					position: mapIsToggled ? 'relative' : 'absolute',
					left: mapIsToggled ? '0' : '-99999px',
				},
			},
		},
	});

export const buttonStyle = cx(
	button(aqua),
	css({
		position: 'fixed',
		top: 'calc(100% - 70px)',
		right: '15px',
		boxShadow: 'rgba(0,0,0,0.22) 0 6px 12px',
		zIndex: '2',
		display: 'none',
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			display: 'block',
		},
	})
);

export const listViewButtonStyle = cx(
	button('#fff'),
	css({
		color: darkGrey,
		position: 'absolute',
		top: 'calc(100% - 70px)',
		right: '15px',
		boxShadow: 'rgba(0,0,0,0.22) 0 6px 12px',
		zIndex: '2',
		display: 'none',
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			display: 'block',
		},
	})
);

export const leftStyle = css({
	marginTop: '15px',
	marginRight: '11px',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		marginRight: '0',
	},
});

export const rightStyle = css({
	marginTop: '25px',
	marginLeft: '11px',
	marginBottom: '25px',
	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		marginLeft: '0',
		marginBottom: '0',
		paddingBottom: '70%',
		position: 'absolute',
	},
});

export const pageNavsStyle = css({
	'& [data-component=PageHeader]:last-child': {
		display: 'none',
	},

	[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
		'& [data-component=PageHeader]:first-child': {
			display: 'none',
		},
		'& [data-component=PageHeader]:last-child': {
			display: 'block',
		},
	},
});

export const filtersWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	margin: '0 auto',
	padding: '14px 20px',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	flexWrap: 'wrap',

	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		// justifyContent: 'flex-start',
	},

	'& [data-component=FilterDropDown]': {
		marginTop: '10px',
		'& > a': {
			paddingRight: '30px',
			width: 'auto',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			width: '100%',
			marginRight: '20px',
		},
	},

	'& [data-component=SingleFieldForm]': {
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			'& input': {
				width: 'calc(100% - 46px)',
			},
		},
	},

	'& select': {
		width: '100%',
		display: 'block',
		border: `1px solid ${lightGrey}`,
		color: darkGrey,
		borderRadius: '4px',
		fontSize: '16px',
		lineHeight: '18px',
		padding: '14px 36px 14px 18px',
		appearance: 'none',
		cursor: 'pointer',
		background: `#F6F6F6 url(${DropDownIcon}) no-repeat calc(100% - 16px) center`,
	},
});

export const filtersContainerStyle = css({
	position: 'relative',
	boxShadow: 'rgba(0,0,0,0.09) 0 6px 12px 0',
	background: '#fff',
	zIndex: '3',

	'& h3': {
		...museo900,
	},

	'& h3:first-child': {
		marginTop: '0',
	}
});

export const filtersInnerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	margin: '0 auto',
	padding: '20px',
});

export const filtersRowStyle = css({
	display: 'flex',
	flexDirection: 'row',
	justifyContent: 'flex-start',
	alignItems: 'flex-start',

	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		flexDirection: 'column',
		'& div:first-child': {
			marginBottom: '20px',
		}
	},
});

export const dropdownStyle = css({
	'&:not(:last-child)': {
		marginRight: '20px',
	}
});

export const searchFieldStyle = css({
	width: '100%',
	display: 'block',
	flexShrink: '0',
});



// WEBPACK FOOTER //
// ./src/page-styles/treatment-services-database/index.js